<!-- <header class="header _dark-header"
>
  <div class="wrapper-header" >
    <a>
      <img src="../../assets/images/logo-white-title.svg" width="91" height="24" alt="HUBX" class="logo _white-title" />
    </a>
    <nav class="nav-wrap" [ngClass]="{'mobile-nav': navToggle}">
      <ul (click)="close()" class="nav">
        <li><a [ngClass]="{'activeLink': sharedService.corporateSiteSelectedLink === 'corphome'}" (click)="navigateTo('corphome')">Our Company</a></li>
        <li><a [ngClass]="{'activeLink': sharedService.corporateSiteSelectedLink === 'products'}" (click)="navigateTo('products')" >Products</a></li>
        <li><a [ngClass]="{'activeLink': sharedService.corporateSiteSelectedLink === 'sell'}" (click)="navigateTo('sell')" >Sell On HUBX</a></li>
        <li><a [ngClass]="{'activeLink': sharedService.corporateSiteSelectedLink === 'aboutUs'}"  (click)="navigateTo('aboutUs')">About Us</a></li>
        <li><a [ngClass]="{'activeLink': sharedService.corporateSiteSelectedLink === 'faq'}" (click)="navigateTo('faq')">FAQ</a></li>
        <li><a [ngClass]="{'activeLink': sharedService.corporateSiteSelectedLink === 'contact-support'}" (click)="navigateTo('contact-support')" (click)="navigateTo('contact-support')">Contact</a></li>
      </ul>
      <ul (click)="close()" class="nav buttons">
        <li *ngIf="!isOnBuyerLogin()"><a  [routerLink]="['']" (click)="navigateTo('guest/home')" class="buyer-button">Buyer Portal</a></li>
        <li *ngIf="!isOnVendorLogin() && !maintenanceModeOn"><a [routerLink]="['/vendor-login']" (click)="navigateTo('vendor-login')" class="vendor-button">Vendor Portal</a></li>
      </ul>
    </nav> 

  </div>

</header> -->


<app-top></app-top>
